var _toString = Object.prototype.toString;
/**
 * @description: 判断值是否未某个类型
 */
export function is(val, type) {
    return _toString.call(val) === "[object " + type + "]";
}
/**
 * @description: 是否为对象
 */
// eslint-disable-next-line
export function isObject(val) {
    return val !== null && is(val, 'Object');
}
/**
 * @description:  是否为函数
 */
// eslint-disable-next-line
export function isFunction(val) {
    return is(val, 'Function');
}
/**
 * @description:  是否为数组
 */
export function isArray(val) {
    return val && Array.isArray(val);
}
/**
 * 判断是否为空数组
 * @param val
 */
export function isEmptyArray(val) {
    return isArray(val) && val.length === 0;
}
/**
 * 数字
 * @param val
 */
export function isNumber(val) {
    return typeof val === 'number';
}
/**
 * 字符串
 * @param val
 */
export function isString(val) {
    return is(val, 'String');
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29yZS9pcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFNLFNBQVMsR0FBRyxNQUFNLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQztBQUU1Qzs7R0FFRztBQUNILE1BQU0sVUFBVSxFQUFFLENBQUMsR0FBWSxFQUFFLElBQVk7SUFDM0MsT0FBTyxTQUFTLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLGFBQVcsSUFBSSxNQUFHLENBQUM7QUFDcEQsQ0FBQztBQUVEOztHQUVHO0FBQ0gsMkJBQTJCO0FBQzNCLE1BQU0sVUFBVSxRQUFRLENBQUMsR0FBWTtJQUNuQyxPQUFPLEdBQUcsS0FBSyxJQUFJLElBQUksRUFBRSxDQUFDLEdBQUcsRUFBRSxRQUFRLENBQUMsQ0FBQztBQUMzQyxDQUFDO0FBRUQ7O0dBRUc7QUFDSCwyQkFBMkI7QUFDM0IsTUFBTSxVQUFVLFVBQVUsQ0FBQyxHQUFZO0lBQ3JDLE9BQU8sRUFBRSxDQUFDLEdBQUcsRUFBRSxVQUFVLENBQUMsQ0FBQztBQUM3QixDQUFDO0FBRUQ7O0dBRUc7QUFDSCxNQUFNLFVBQVUsT0FBTyxDQUFDLEdBQVE7SUFDOUIsT0FBTyxHQUFHLElBQUksS0FBSyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQztBQUNuQyxDQUFDO0FBRUQ7OztHQUdHO0FBQ0gsTUFBTSxVQUFVLFlBQVksQ0FBQyxHQUFRO0lBQ25DLE9BQU8sT0FBTyxDQUFDLEdBQUcsQ0FBQyxJQUFJLEdBQUcsQ0FBQyxNQUFNLEtBQUssQ0FBQyxDQUFDO0FBQzFDLENBQUM7QUFFRDs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsUUFBUSxDQUFDLEdBQVE7SUFDL0IsT0FBTyxPQUFPLEdBQUcsS0FBSyxRQUFRLENBQUM7QUFDakMsQ0FBQztBQUVEOzs7R0FHRztBQUNILE1BQU0sVUFBVSxRQUFRLENBQUMsR0FBUTtJQUMvQixPQUFPLEVBQUUsQ0FBQyxHQUFHLEVBQUUsUUFBUSxDQUFDLENBQUM7QUFDM0IsQ0FBQyJ9